import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { CONST_DEL_GENRE_FILTER } from 'features/Genre/constans';
import { Genre, Sortable } from 'features/Genre/models/Genre';
import AddModal from 'features/Genre/pages/add/AddModal';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import { TfiReload } from 'react-icons/tfi';
import DetailModal from '../../detail/Detail';
import service from '../services';
// define props
interface DataTableProps {
  dataTable: Genre[];
  setSort: (sort: Sortable) => void;
  setDataTable: (dataTable: Genre[] | []) => void;
  sort: Sortable;
}

function TableList({ dataTable, sort, setSort, setDataTable }: DataTableProps) {
  const { t } = useTranslation();
  const initialState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
  const [checked, setChecked] = useState<any>(initialState);
  const refBtnDetail = useRef<HTMLButtonElement>(null);
  const refBtnDelete = useRef<HTMLButtonElement>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [idDetail, setIdDetail] = useState<string>('');
  const { showGlobalModal } = useGlobalModal();

  // handle checked all
  function handleCheckedAll() {
    const newState = dataTable.reduce((o, key) => ({ ...o, [key.id]: true }), {});
    setChecked(newState);
  }

  // handle unchecked all state changes
  function handleUncheckedAll() {
    const newState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
    setChecked(newState);
  }

  // toggle checkbox
  function toggleCheck(value: number) {
    let newState = { ...checked };
    newState[value] = !newState[value];
    setChecked(newState);
  }

  // handle reload
  async function handleReload() {
    await service.getGenres('', CONST_DEL_GENRE_FILTER.HIDE_DEL).then((result) => {
      setDataTable(result.data);
    });
    handleUncheckedAll();
  }

  // sort ascending name
  function handleSortDownName() {
    dataTable.sort(function (a, b) {
      if (b.name > a.name) {
        return -1;
      }
      if (b.name > a.name) {
        return 1;
      }
      return 0;
    });
    setSort({ ...sort, name: -1, note: 0 });
  }

  // sort descending name
  function handleSortUpName() {
    dataTable.sort(function (a, b) {
      if (a.name > b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    setSort({ ...sort, name: 1, note: 0 });
  }

  // sort ascending note
  function handleSortDownNote() {
    dataTable.sort(function (a, b) {
      if (b.note > a.note) {
        return -1;
      }
      if (b.note > a.note) {
        return 1;
      }
      return 0;
    });
    setSort({ ...sort, note: -1, name: 0 });
  }

  // sort descending note
  function handleSortUpNote() {
    dataTable.sort(function (a, b) {
      if (a.note > b.note) {
        return -1;
      }
      if (a.note > b.note) {
        return 1;
      }
      return 0;
    });
    setSort({ ...sort, note: 1, name: 0 });
  }

  // useEffects check change checked
  useEffect(() => {
    // handle disabled btn view detail
    function handleDisableBtnDelte() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 0) {
        return false;
      }
      return true;
    }

    // handle disabled btn view detail
    function handleDisableBtnViewDetail() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 1 || count === 0) {
        return true;
      }
      return false;
    }

    if (handleDisableBtnViewDetail()) {
      if (refBtnDetail.current) refBtnDetail.current.disabled = true;
    } else {
      if (refBtnDetail.current) refBtnDetail.current.disabled = false;
    }
    if (handleDisableBtnDelte()) {
      if (refBtnDelete.current) refBtnDelete.current.disabled = true;
    } else {
      if (refBtnDelete.current) refBtnDelete.current.disabled = false;
    }

    let ids = Object.keys(checked).filter((key) => checked[key] === true);
    setIdDetail(ids[0]);
  }, [checked]);

  // handle function go to default page
  function handleDefaultGenre() {
    setShowEditModal(true);
  }

  function handleBtnAddNewGenre() {
    setShowAddModal(true);
  }

  // delete muilti record
  async function handleClickBtnDeleteAll() {
    let idsArr = Object.keys(checked).filter((key) => {
      if (checked[key] === true) {
        return parseInt(key);
      }
      return null;
    });
    let ids = idsArr
      .map((value) => {
        return parseInt(value);
      })
      .join(',');
    await service
      .deleteGenres(ids)
      .then(async () => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleReload}
              title={t('Genre.Validator.success')}
              message={t('Genre.Validator.delete_success')}
            ></AlertModal>
          ));
      })
      .catch((err: any) => {
        <AlertModal title={t('Genre.Validator.error')} message={t('Genre.Validator.500')}></AlertModal>;
      });
  }
  // close modal add
  function handleCloseModalAdd() {
    setShowAddModal(false);
    handleReload();
  }

  // close modal edit
  function handleCloseModalEdit() {
    setShowEditModal(false);
    handleUncheckedAll();
  }

  async function handleRestore(id: number) {
    await service
      .restoreDelete(id)
      .then(async () => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={handleReload}
              title={t('Genre.Validator.success')}
              message={t('Genre.Validator.restore_success')}
            ></AlertModal>
          ));
      })
      .catch((err: any) => {
        <AlertModal title={t('Genre.Validator.error')} message={t('Genre.Validator.500')}></AlertModal>;
      });
  }

  return (
    <>
      <Row className="mb-2">
        <Col sm={2} lg={2}>
          <button
            className="btn btn-link ps-0"
            style={{ textDecoration: 'none', minWidth: 'inherit' }}
            onClick={handleCheckedAll}
          >
            {t('Genre.Button.select_all')}
          </button>
          /
          <button
            className="btn btn-link"
            style={{ textDecoration: 'none', minWidth: 'inherit' }}
            onClick={handleUncheckedAll}
          >
            {t('Genre.Button.cancel_all')}
          </button>
          <span className="ps-2 pe-2"></span>
          <button className="btn btn-link" style={{ textDecoration: 'none' }} onClick={handleReload}>
            <span className="bg-primary rounded-circle d-inline-flex p-2">
              <TfiReload size={12} color="#fff" />
            </span>
            {t('Genre.Button.reload')}
          </button>
        </Col>
        <Col sm={10} lg={10} className="d-flex justify-content-end">
          <button ref={refBtnDetail} type="button" className="btn btn-primary" onClick={handleDefaultGenre}>
            {t('Genre.Button.detail')}
          </button>
          <DetailModal
            id={idDetail}
            show={showEditModal}
            handleCloseModalEdit={handleCloseModalEdit}
            dataTable={dataTable}
            setDataTable={setDataTable}
          />
          <span className="ps-2 pe-2"></span>
          <button type="button" ref={refBtnDelete} className="btn btn--red" onClick={handleClickBtnDeleteAll}>
            {t('Genre.Button.delete')}
          </button>
          <span className="ps-2 pe-2"></span>
          <button type="button" className="btn btn--dark-green" onClick={handleBtnAddNewGenre}>
            {t('Genre.Button.add_new')}
          </button>
          <AddModal
            show={showAddModal}
            handleCloseModalAdd={handleCloseModalAdd}
            dataTable={dataTable}
            setDataTable={setDataTable}
          />
        </Col>
      </Row>
      <div className="sticky-table flex-grow-1 flex-shrink-1 mt-1">
        <Table bordered className="genre-list">
          <thead className="text-center">
            <tr>
              <th rowSpan={2} className="align-top" style={{ width: '5%' }}>
                {t('Genre.Table.selection')}
              </th>
              <th
                rowSpan={1}
                className="align-top"
                style={{ width: '30%' }}
                onClick={
                  sort.name === 1
                    ? handleSortDownName
                    : sort.name === -1
                    ? handleSortUpName
                    : sort.name === 0
                    ? handleSortDownName
                    : undefined
                }
              >
                {t('Genre.Table.genre_name')}
                {sort.name === 1 ? <FaSortDown className="fs-4" /> : null}
                {sort.name === -1 ? <FaSortUp className="fs-4" /> : null}
                {sort.name === 0 ? <FaSort className="fs-4" /> : null}
              </th>
              <th
                rowSpan={2}
                className="align-top"
                onClick={
                  sort.note === 1
                    ? handleSortDownNote
                    : sort.note === -1
                    ? handleSortUpNote
                    : sort.note === 0
                    ? handleSortDownNote
                    : undefined
                }
              >
                {t('Genre.Table.remarks')}
                {sort.note === 1 ? <FaSortDown className="fs-4" /> : null}
                {sort.note === -1 ? <FaSortUp className="fs-4" /> : null}
                {sort.note === 0 ? <FaSort className="fs-4" /> : null}
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {dataTable &&
              dataTable.map((value: Genre) => (
                <tr key={value.id} className={value.delete_flg ? 'deleted_row ' : ''}>
                  <td>
                    {!value.delete_flg ? (
                      <Form.Check
                        type="checkbox"
                        value={value.id}
                        checked={checked[value.id]}
                        disabled={value.delete_flg}
                        onChange={() => toggleCheck(value.id)}
                      ></Form.Check>
                    ) : (
                      <Button
                        className="btn--orange"
                        onClick={() => {
                          handleRestore(value.id);
                        }}
                      >
                        {t('Genre.Button.restore')}
                      </Button>
                    )}
                  </td>
                  <td>{value.name}</td>
                  <td title={value.note}>
                    <span className="ms-1">
                      {value.note.slice(0, 15)} {value.note && '...'}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default TableList;
